/**
 * Allowlist: the shared `Header` renders on every StandardLayout/CardLayout
 * page, so a new route must opt in deliberately. Anchored at both ends, and
 * `[^/]+` matches a single segment so a route pattern and a resolved URL both
 * work — that is what keeps detail and legacy surfaces out.
 */
const browseNavRoutes = [
  /^\/buy\/user\/[^/]+\/bids\/?$/,
  /^\/buy\/user\/[^/]+\/offers\/?$/,
  /^\/buy\/user\/[^/]+\/orders\/?$/,
  /^\/buy\/user\/[^/]+\/disputes\/?$/,
  /^\/buy\/user\/[^/]+\/contracts\/?$/,
]

export function shouldShowAccountBrowseNav(
  pathname: string | null | undefined
): boolean {
  if (!pathname) return false

  return browseNavRoutes.some((pattern) => pattern.test(pathname))
}
